const DEFAULT_WIDTH = 1200;

class CloudinaryPdf {
    constructor(res) {
        this.res = res;
        this.getPage = this.getPage.bind(this);
        this.getPages = this.getPages.bind(this);
        this.getPageUrl = this.getPageUrl.bind(this);
    }

    getPageUrl({ path, assetId, page, width }) {
        return `${this.res}/${path}/w_${width},q_auto,f_auto,pg_${page}/${assetId}`;
    }

    getPage({ path, assetId, page = 1, width = DEFAULT_WIDTH }) {
        return new Promise((res, rej) => {
            const img = new Image();
            const src = this.getPageUrl({ path, assetId, page, width });
            img.onload = () => res({ index: page - 1, src });
            img.onerror = () => rej({ index: page - 1, src: null });
            img.src = src;
        });
    }

    getBatch({ path, assetId, fromPage, batchSize, width, onBatchLoaded, onPageLoaded }) {
        const requests = [];
        for (let i = 0; i < batchSize; i++) {
            // Handled rejections (with .catch) are passed to .all as resolved :)
            requests[i] = this.getPage({
                path, assetId, width,
                page: fromPage + i
            }).then((page) => {
                onPageLoaded && onPageLoaded(page);
                return page;
            }).catch((err) => err);
        }
        Promise.all(requests).then((pages) => {
            const validPages = pages.filter((p) => p.src);
            onBatchLoaded({
                fromPage,
                batchSize,
                pages: validPages,
                isLastBatch: validPages.length !== pages.length
            });
        });
    }

    getPages({ path, assetId, batchSize = 1, onPageLoaded = null, onBatchLoaded = null, width = DEFAULT_WIDTH }) {
        return new Promise((resolve, reject) => {
            let fromPage = 1;
            const pages = [];
            const onBatch = (batch) => {
                if (batch) {
                    batch.pages.forEach((p) => pages[p.index] = p.src);
                    onBatchLoaded && onBatchLoaded(batch);
                    if (batch.isLastBatch) {
                        return pages.length ? resolve(pages) : reject();
                    }
                    fromPage += batchSize;
                }
                this.getBatch({ path, assetId, fromPage, batchSize, width, onBatchLoaded: onBatch, onPageLoaded });
            };
            onBatch();
        });
    }

    static getPartsFromUrl(url) {
        const matches = url.match(/(https:\/\/.*cloudinary\.com)\/(images?\/(upload\/)?)?(([a-z]_\w+[/,])+)?(.+)/),
            idWithExtension = matches ? matches[6] : null,
            idWithoutExtension = idWithExtension ? idWithExtension.replace(/\.\w+$/, '') : null;
        return {
            res: matches[1],
            path: (matches[2] || '').replace(/\/$/, ''),
            transformations: (matches[4] || '').replace(/\/$/, ''),
            assetId: idWithoutExtension
        };
    }
}

export default CloudinaryPdf;
